import dayjs from 'dayjs'
import { EVENT_STATUS_PUBLISHED } from '../../../../constants'

export const DAY_KEY_FORMAT = 'YYYY-MM-DD'

export const isPublished = (status) => status === EVENT_STATUS_PUBLISHED

export function buildMonthCells(month) {
  const monthStart = dayjs(`${month}-01`).startOf('month')
  const first = monthStart.startOf('week')
  const last = monthStart.endOf('month').endOf('week')
  const cells = []
  let current = first
  while (current.isBefore(last)) {
    cells.push(current)
    current = current.add(1, 'day')
  }
  return cells
}

export function bucketEventsByDay(items) {
  return items.reduce((buckets, item) => {
    const key = dayjs(item.startAt).format(DAY_KEY_FORMAT)
    if (!buckets[key]) buckets[key] = []
    buckets[key].push(item)
    return buckets
  }, {})
}
